import { z } from "@/zod";
import { ulid, dateTime } from "./commonFields";

export const contractorCard = z.object({
  id: ulid,
  project_id: ulid,
  project_name: z.string(),
  store_id: ulid,
  store_name: z.string(),
  contractor_id: ulid,
  contractor_name: z.string(),
  period: z.string(),
  contractor_card_required: z.boolean(),
  card_s3_key: z.string().optional(),
  card_filename: z.string().optional(),
  card_mimetype: z.string().optional(),
  store_coordinator_name: z.string().nullable(),
  supervisor_name: z.string().nullable(),
  regional_representative_name: z.string().nullable(),
  regional_director_name: z.string().nullable(),
  created_at: dateTime,
  updated_at: dateTime,
});

export const readContractorCard = contractorCard.readonly();
export const displayContractorCard = contractorCard
  .omit({
    created_at: true,
    updated_at: true,
    card_mimetype: true,
    card_s3_key: true,
  })
  .readonly();

export const updateContractorCard = z.object({
  content: z.string().optional(),
  filename: z.string().optional(),
});

export type ReadContractorCard = z.infer<typeof readContractorCard>;
export type DisplayContractorCard = z.infer<typeof displayContractorCard>;
export type UpdateContractorCard = z.infer<typeof updateContractorCard>;
